import React, { useState, useCallback  } from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash'
import Track from '../../analytics/Track';
import './Footer.sass';
import appleBadge from './app-store-badge.png';
import googleBadge from './google-play-badge.png';
import logo from '../HomePage/assets/clustertruck-logo.png'
import nowHiringBadge from './hire-badge.svg'

const FoodNotice = ({displayNotice}) => (
  displayNotice ?
    <p>
      Our meals are prepared in a kitchen environment that contains nuts, gluten, shellfish, and dairy.
      We use best practices when preparing our meals, however, inadvertent cross-contamination may occur.
      We cannot guarantee the complete absence of allergens.
      Consuming raw or undercooked meats, poultry, seafood, shellfish, or eggs may increase your risk of food-borne illness.
    </p> : null
);

const KitchenAddr = ({ address_1, city, state, zip_code }) => (
  <div style={{ marginTop: "16px" }}>
    <addr>
      {address_1} <br />
      {city}, {state}, {zip_code}
    </addr>
  </div>
);

const Footer = ({kitchen}) => {
  const [displayNotice, setDisplayNotice] = useState(false);

  const toggleFoodNotice = useCallback(
    (e) => {
      e.preventDefault();
      setDisplayNotice(!displayNotice);
    },
    [displayNotice, setDisplayNotice]
  );

  const domain = get(window, 'ENV.ENV_DOMAIN');

  return (
    <footer className="site-footer">
      <div className="container">
        <p class="footer-top-links footer-list">
          <a target="_blank" rel="noreferrer" href="/menu?utm_source=footer">Menu</a>
          <a target="_blank" rel="noreferrer" href={`https://${domain}/giftcards`}>Gift Cards</a>
          <a target="_blank" rel="noreferrer" href="http://shopclustertruck.com/">Shop Merch</a>
          <div class="hire-badge">
          <a rel="noreferrer" href={`https://www.${domain}/careers`}>Careers</a>
          <img alt="Now Hiring" src={nowHiringBadge} />
          </div>
          <a target="_blank" rel="noreferrer" href="https://ownaclustertruck.com/">Own a ClusterTruck</a>
        </p>
        <div class="logo-container"><img class="logo" src={logo} alt="ClusterTruck" /></div>
        <h4>Try ordering from any of our apps!</h4>
        <div className="footer-app-badges footer-list">
        <Track>
          <a
            id="add-to-slack-btn-footer"
            data-position='footer'
            style={{margin: '0 0.5rem'}}
            href="https://slack.com/oauth/authorize?client_id=310163802594.454374843925&amp;scope=channels:read,chat:write:bot,links:read,bot,commands">
            <img
              alt="Add to Slack"
              height="40"
              width="139"
              src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" />
            </a>
          </Track>
          <Track>
            <a
              id="mobile-app-badge-apple"
              data-vendor="apple"
              className="app-store-badge app-badge"
              href="https://geo.itunes.apple.com/us/app/clustertruck/id1076372726?mt=8">
              <img src={appleBadge} alt="Download on the App Store" />
            </a>
          </Track>
          <Track>
            <a
              id="mobile-app-badge-google"
              data-vendor="google"
              className="app-store-badge app-badge"
              href="https://play.google.com/store/apps/details?id=com.clustertruck.consumer">
              <img src={googleBadge} alt="Get it on Google Play" />
            </a>
          </Track>
        </div>

        <p className="footer-links footer-list">
          <a
          href="https://vault.pactsafe.io/s/5169d190-416b-4052-ac2d-1825725fde08/legal.html#contract-h16uzs1if">
            Privacy Policy
          </a>
          {' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://vault.pactsafe.io/s/5169d190-416b-4052-ac2d-1825725fde08/legal.html#contract-r1l-cxh0z">
            Terms &amp; Conditions
          </a>
          {' '}
          <Link to="/licenses">
            Licenses
          </Link>
          {' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://docs.google.com/document/d/e/2PACX-1vTkoONe2uA7A9qzDKGJuStYvPmi95ES_1mDskOxW9fdIixRNHbybZTZX7NppxhyiZQfwNvq1PaJ2qn_/pub">
            Coronavirus Information
          </a>
          {' '}
          <button
            className='food-allergy-btn'
            onClick={toggleFoodNotice}>
            Food Allergy Notice
          </button>
        </p>

        <small className="copyright">
          &copy; ClusterTruck, Inc. All rights reserved.
        </small>

        <KitchenAddr {...kitchen} />

        <FoodNotice {...{displayNotice}} />
      </div>
    </footer>
  );
}

export default Footer;
